export default function Banners() {
    return (
        <div className="about__img">
            <picture>
                <img className="w-100 " src="https://www.pride.ru/images/uploaded/banners/b1010e0a2d92f693d7f3e770e3ca1a05f8dba02b.jpeg" alt=""/>
            </picture>
        </div>
    );
}